// extracted by mini-css-extract-plugin
export var backdropBlur = "_ch-0";
export var contentCard = "_ch-5";
export var frame = "_ch-2";
export var image = "_ch-4";
export var imagePane = "_ch-3";
export var modal = "_ch-1";